const pageList = [
    { code: "sysPermission", url: "/Permission/List", name: "权限信息" },
    { code: "platomCompany", url: "/Company/List", name: "公司信息" },
]

//code可以是URL或编码，先尝试URL后尝试Code
export function getPageMap(code) {
    if (pageList.some(p => p.url === code)) return pageList.find(p => p.url === code)
    else if (pageList.some(p => p.code === code)) return pageList.find(p => p.code === code)
    throw new Error(`未找到页面配置：${code}`)
}